var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ax-avatar-default ax-avatar-default__image"},[_c('AxIcon',{staticClass:"ax-avatar-default__icon",attrs:{"name":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }